import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjsDuration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import 'dayjs/locale/es';

dayjs.locale('es');
dayjs.extend(customParseFormat);
dayjs.extend(dayjsDuration);
dayjs.extend(utc);
dayjs.extend(timezone);

export default dayjs;
